// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_hw","advertCardPhoto__image":"c-a_hx"};